<template>
    <header class="header">
        <Navigation @moveToSection="moveToSection(chapter)" />

        <div class="sidebar">
            <ul>
                <li class="sidebar__item-1" v-on:click="moveToSection(2)"><span v-html="$t('GLOBAL_MENU_01')" class="text--secondary-color">Introduction</span></li>
                <li class="sidebar__item-2" v-on:click="moveToSection(3)"><span v-html="$t('GLOBAL_MENU_02')">Key information</span></li>
                <li class="sidebar__item-3" v-on:click="moveToSection(4)"><span v-html="$t('GLOBAL_MENU_03')">How it works</span></li>
                <li class="sidebar__item-4" v-on:click="moveToSection(5)"><span v-html="$t('GLOBAL_MENU_04')">At the counter</span></li>
            </ul>

        </div>
    </header>
</template>

<script>
    import { EventBus } from '../../main';
    import Navigation from "@/components/partials/Navigation";

    export default {
        name: "Header",
        components: {
            Navigation,
            EventBus
        },
        data() {
            return {
                lang: ""
            }
        },
        methods: {
            moveToSection(chapter) {
                EventBus.$emit('moveToSection', [chapter]);

            },

        }
    }
</script>

<style scoped>

</style>